/**
 * Date affichée au-dessus du bonjour, façon « Dimanche 5 juillet ».
 *
 * Les noms de jours et de mois viennent d'`Intl`, jamais de nos fichiers de
 * traduction : ils existent déjà dans toutes les locales (même choix que pour
 * `DatePicker`). Seule la capitale initiale est ajoutée — le français rend
 * « dimanche 5 juillet », la maquette montre une majuscule.
 */
export function formatGreetingDate(date: Date, locale: string): string {
  const texte = new Intl.DateTimeFormat(locale, {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  }).format(date);

  return texte.charAt(0).toLocaleUpperCase(locale) + texte.slice(1);
}
